import { STGrouping, SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import { PresetChartType } from '../chart-presets/const';
import type { IAreaChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

export class AreaChart extends BaseSubChart implements IAreaChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.AreaChart, uiData, sdkData, rawUiData);
    }
    public type = SubChartType.AreaChart;
    /**
     * 柱形图分组类型
     */
    public grouping?: STGrouping;

    public getPresetChartType(): PresetChartType {
        switch (this.grouping) {
            case STGrouping.stacked:
                return PresetChartType.AREA_STACKED;
            case STGrouping.percentStacked:
                return PresetChartType.AREA_PERCENT_STACKED;
            default:
                return PresetChartType.AREA;
        }
    }
}
